/**
 * PoppinPay API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import ItemModifierList from './ItemModifierList';
import Variation from './Variation';

/**
* The Item model module.
* @module model/Item
* @version 1.0.0
*/
export default class Item {
    /**
    * Constructs a new <code>Item</code>.
    * @alias module:model/Item
    * @class
    */

    constructor() {
        
        
        
    }

    /**
    * Constructs a <code>Item</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/Item} obj Optional instance to populate.
    * @return {module:model/Item} The populated <code>Item</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Item();
                        
            
            if (data.hasOwnProperty('Id')) {
                obj['Id'] = ApiClient.convertToType(data['Id'], 'String');
            }
            if (data.hasOwnProperty('Name')) {
                obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
            }
            if (data.hasOwnProperty('Description')) {
                obj['Description'] = ApiClient.convertToType(data['Description'], 'String');
            }
            if (data.hasOwnProperty('ImageUrl')) {
                obj['ImageUrl'] = ApiClient.convertToType(data['ImageUrl'], 'String');
            }
            if (data.hasOwnProperty('SkipModifierScreen')) {
                obj['SkipModifierScreen'] = ApiClient.convertToType(data['SkipModifierScreen'], 'Boolean');
            }
            if (data.hasOwnProperty('Ordinal')) {
                obj['Ordinal'] = ApiClient.convertToType(data['Ordinal'], 'Number');
            }
            if (data.hasOwnProperty('Variations')) {
                obj['Variations'] = ApiClient.convertToType(data['Variations'], [Variation]);
            }
            if (data.hasOwnProperty('Taxes')) {
                obj['Taxes'] = ApiClient.convertToType(data['Taxes'], ['String']);
            }
            if (data.hasOwnProperty('ModifierLists')) {
                obj['ModifierLists'] = ApiClient.convertToType(data['ModifierLists'], [ItemModifierList]);
            }
        }
        return obj;
    }

    /**
    * @member {String} Id
    */
    'Id' = undefined;
    /**
    * @member {String} Name
    */
    'Name' = undefined;
    /**
    * @member {String} Description
    */
    'Description' = undefined;
    /**
    * @member {String} ImageUrl
    */
    'ImageUrl' = undefined;
    /**
    * @member {Boolean} SkipModifierScreen
    */
    'SkipModifierScreen' = undefined;
    /**
    * @member {Number} Ordinal
    */
    'Ordinal' = undefined;
    /**
    * @member {Array.<module:model/Variation>} Variations
    */
    'Variations' = undefined;
    /**
    * @member {Array.<String>} Taxes
    */
    'Taxes' = undefined;
    /**
    * @member {Array.<module:model/ItemModifierList>} ModifierLists
    */
    'ModifierLists' = undefined;




}
